export default "__VITE_PUBLIC_ASSET__3b19fdb7__"